<div class="row justify-content-center">
    <div class="col-12 col-md-9 col-lg-8">
        <div class="alert alert-warning Messages.Profile.EmailVerificationPending alert-dismissible"
        role="alert" id="account-delete-pending">
            <div [innerHtml] = "'Messages.Profile.AccountDeletePending'|translate:this"></div>
        </div>
        <hr class="subtle mt-4"/>
    </div>
</div>
